import { useGlobalState } from '@libs/client'
import { usePromotions, useSetting, useSettingDefault } from '@ui/hooks'
import { ShopHelpLocalKey } from '@ui/services'
import css from 'styled-jsx/css'
import SaleItem from '../sell-item'

export default function OrderTrackingSale({
  className,
  version
}: {
  className?: string
  version?: string
}) {
  const orderTrackingSale = useSettingDefault()?.setting.settings?.general?.cross_sell
    ?.order_tracking
  const [storeSetting] = useSetting('store')
  const [orderDetail] = useGlobalState<Types.OrderShopHelp>(ShopHelpLocalKey.ORDER_DETAIL)

  const promotions = usePromotions()
  const productLabel = (storeSetting?.general?.title || '').split('-')?.[0]?.trim()

  const surfixQuery = `utm_source=selless&utm_campaign=tracking-page-${version}&utm_content=${
    storeSetting?.general?.id || ''
  }&utm_medium=${encodeURIComponent(window.location.href)}&sclid=${orderDetail?.id || ''}`

  return (
    <div className={`order-tracking-catalog ${className}`} id="order-tracking-catalog">
      <style jsx global>
        {globalStyle}
      </style>
      <div className="wrapper">
        <div className="page__content section">
          <div className="store">
            <div className="sub-title is-hidden-mobile">
              <div className="sub-title__content">SPECIAL OFFER</div>
            </div>
            <span className="store__title">{orderTrackingSale?.title}</span>
          </div>
          <div className="columns">
            {!!orderTrackingSale?.items?.length &&
              orderTrackingSale?.items
                .filter((x) => x.product_label != productLabel)
                ?.map((item, index) => (
                  <div
                    key={`${index}-order-tracking-sale`}
                    className="column is-12-mobile is-6-tablet is-4-desktop"
                  >
                    <div
                      onClick={() =>
                        window.open(
                          `https://${item.url}?${surfixQuery}${
                            orderTrackingSale?.apply_discount
                              ? `&p=${item?.discount_code || ''}`
                              : ''
                          }`,
                          '_self'
                        )
                      }
                      className={`store-card ${
                        orderTrackingSale?.items?.length &&
                        index ===
                          orderTrackingSale?.items.filter((x) => x.product_label != productLabel)
                            ?.length -
                            1
                          ? 'border-bottomed'
                          : ''
                      }`}
                    >
                      <SaleItem
                        item={item}
                        discountNumber={promotions?.[item.discount_code || '']?.value || 0}
                      />
                    </div>
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>
  )
}

const globalStyle = css.global`
  .order-tracking-catalog {
    display: block;

    .page__content {
      max-width: 1208px;
      min-height: auto;

      &.section {
        padding-top: 4px !important;
      }

      .store {
        display: flex;
        padding-bottom: 16px;
        padding: 12px 0px 32px;
        align-items: center;
        justify-content: center;
        .sub-title {
          display: none;
          margin-right: 16px;
          &__content {
            color: #ffffff;
            font-weight: 600;
            font-size: 18px;
            line-height: 30px;
            background: #e53935;
            border-radius: 4px;
            padding: 4px 16px;
          }
        }

        &__title {
          text-align: center;
          font-weight: 600;
          font-size: 30px;
          line-height: 40px;
        }
      }
    }

    .content {
      h3 {
        margin-bottom: 0px;
      }
    }

    .sale-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 32px;
      display: flex;
      align-items: flex-end;
      color: #363636;
    }

    .columns {
      flex-wrap: wrap;
      grid-row-gap: 32px;
    }
    .store-card {
      padding: 16px 0 40px;
      border-bottom: 1px solid #e0e3e9;
      .info {
        padding: 12px 0 16px;
        display: flex;
        align-items: center;
        .thumbnail {
          margin: 0;
          min-width: 180px;
          height: 180px;
          border: 1px solid #eaecf0;
          border-radius: 4px;
          margin-right: 16px;
          img {
            width: 180px;
            height: 180px;
            object-fit: cover;
          }
        }
      }

      .sale-info {
        display: flex;
        flex-direction: column;

        .price {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding-bottom: 18px;
          .default {
            font-weight: 600;
            font-size: 24px;
            line-height: 36px;
            color: #363636;
            margin-right: 8px;
          }

          .compared {
            text-decoration-line: line-through;
            font-weight: 400;
            font-size: 14px;
            line-height: 31px;
            color: #363636;
          }
        }
        .star-rating {
          margin-bottom: 8px;
          height: 15px;
        }
      }

      button {
        height: 52px;
        width: 100%;
        border: 1px solid #818181;
        border-radius: 4px;
        color: #363636;
        font-weight: 600;
        font-size: 16px;
        line-height: 28px;
      }

      .discount {
        display: flex;
        margin-bottom: 8px;
        &__number {
          background: #ef5350;
          border-radius: 4px;
          padding: 0 8px;
          font-weight: 600;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0.02em;
          color: #ffffff;
        }
      }

      .store-hidden {
        display: none;
      }
      .store-block {
        display: block;
      }
    }

    @media screen and (min-width: 375px) {
      .store-card {
        .sale-info {
          .price {
            flex-direction: row;
            align-items: flex-end;
          }
        }
      }
    }
    @media screen and (max-width: 768px) {
      .border-bottomed {
        border-bottom: none;
      }
    }

    @media screen and (min-width: 768px) {
      .store-card {
        background-color: #fff;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        height: 100%;

        border: 1px solid #eaecf0;
        border-radius: 8px;

        padding: 0;

        .thumbnail {
          height: 284px;
          overflow: hidden;

          img {
            width: 100%;
            object-fit: cover;
          }
        }

        .title {
          margin: 0 24px 16px;
          font-weight: 600;
          font-size: 15px;
          line-height: 24px;
          flex: 1;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .content {
          position: relative;
          flex: 1;
        }

        .info {
          transition: opacity 0.2s ease-in-out;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: start;
          padding: 0;
          .star-rating {
            margin: 24px 24px 12px;
          }

          &__price {
            display: flex;
            align-items: center;
            width: 100%;
            .discount {
              margin-left: auto;
              margin-bottom: 12px;
              &__number {
                font-size: 15px;
                padding: 4px 14px;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
              }
            }

            .price {
              margin-right: auto;
              display: flex;
              align-items: flex-end;
              padding: 0 0 24px 24px;
              .default {
                font-weight: 600;
                font-size: 24px;
                line-height: 40px;
                color: #282828;
                margin-right: 8px;
              }
              .compared {
                text-decoration-line: line-through;
                font-weight: 400;
                font-size: 14px;
                line-height: 33px;
                color: #5b5b5b;
              }
            }
          }
        }

        .view-button {
          transition: opacity 0.3s ease-in-out;
          position: absolute;
          opacity: 0;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;

          button {
            height: 48px;
            width: 200px;
            max-width: 90%;
          }
        }

        &:hover {
          .info {
            opacity: 0;
          }

          .view-button {
            opacity: 1;

            button {
              color: var(--primary-invert);
            }
          }
        }

        &.inactive {
          cursor: default;
          button {
            cursor: default;
          }
        }
      }
    }
  }
  @media screen and (min-width: 768px) {
    .order-tracking-catalog {
      .page__content {
        .store {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px 0 41px;
          .sub-title {
            display: none;
            margin-right: 16px;
            &__content {
              color: #ffffff;
              font-weight: 600;
              font-size: 18px;
              line-height: 30px;
              background: #e53935;
              border-radius: 4px;
              padding: 4px 16px;
            }
          }
          &__title {
            /* font-weight: 600;
          font-size: 24px;
          line-height: 40px; */
            text-align: center;
            font-weight: 600;
            font-size: 36px;
            line-height: 48px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1115px) {
    .order-tracking-catalog {
      .page__content {
        .store {
          .sub-title {
            display: flex;
          }
        }
      }
    }
  }
`
